export default __webpack_public_path__ + "static/ABCMonumentGrotesk-Medium-52f8be3515bd553f3c4b3503d6b76e04.woff";